(function () {
  'use strict';

  var root = document.querySelector('.pankaj-page');
  if (!root) return;

  var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
  var cartUrl = root.dataset.cartUrl || '/cart';
  var checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  var sectionId = root.dataset.sectionId || '';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (moneyFormat.indexOf('with_comma_separator') !== -1) {
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      amount = parts.join(',');
    } else if (moneyFormat.indexOf('comma') !== -1) {
      amount = amount.replace('.', ',');
    }
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* Kaching Bundles — sync CTA + sticky bar with widget selection */
  var bundlesWrap = root.querySelector('.pankaj-bundles');
  var ctaPrice = root.querySelector('#ctaPrice');
  var sPrice = root.querySelector('#stickyPrice');
  var sQty = root.querySelector('#stickyQty');
  var variantInput = root.querySelector('#pankaj-variant-id');
  var form = root.querySelector('#pankaj-product-form');
  var buyBtn = root.querySelector('#buyNow');
  var stickyBuy = root.querySelector('#stickyBuy');

  function syncFromKaching() {
    if (!bundlesWrap) return;
    var selected = bundlesWrap.querySelector('.kaching-bundles__bar--selected');
    if (!selected) return;

    var priceEl = selected.querySelector('.kaching-bundles__bar-price');
    var titleEl = selected.querySelector('.kaching-bundles__bar-title');
    var subtitleEl = selected.querySelector('.kaching-bundles__bar-subtitle, .kaching-bundles__bar-second-line');
    var priceText = priceEl ? priceEl.textContent.trim() : '';

    if (ctaPrice && priceText) ctaPrice.textContent = priceText;
    if (sPrice && priceText) sPrice.textContent = priceText;

    if (sQty) {
      var label = titleEl ? titleEl.textContent.trim() : '';
      var sub = subtitleEl ? subtitleEl.textContent.trim() : '';
      sQty.textContent = sub ? label + ' · ' + sub : label;
    }

    if (variantInput && form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value) variantInput.value = idInput.value;
    }
  }

  function initKachingSync() {
    if (!bundlesWrap) return;
    syncFromKaching();

    var observer = new MutationObserver(function () {
      syncFromKaching();
    });
    observer.observe(bundlesWrap, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked']
    });

    bundlesWrap.addEventListener('click', function () {
      setTimeout(syncFromKaching, 60);
    });

    root.querySelectorAll('kaching-bundle, kaching-bundle-deals').forEach(function (el) {
      el.addEventListener('deal-bar-selected', syncFromKaching);
    });
  }

  window.addEventListener('kaching-bundles-initialized', initKachingSync);
  if (window.kachingBundlesInitialized) initKachingSync();
  else setTimeout(initKachingSync, 800);

  /* add to cart */
  function getCartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return base.indexOf('.js') !== -1 ? base : base + '.js';
  }

  function addToCart(e) {
    if (e) e.preventDefault();
    if (!form) return;

    var btn = buyBtn || stickyBuy;
    if (btn) btn.disabled = true;

    var formData = new FormData(form);
    fetch(getCartAddUrl(), {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          alert(data.description || data.message || 'Could not add to cart.');
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        redirectToCheckout();
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }

  function redirectToCheckout() {
    window.location.href = (window.routes && window.routes.checkout_url) ? window.routes.checkout_url : checkoutUrl;
  }

  if (form) {
    form.addEventListener('submit', addToCart);
  }

  if (stickyBuy) {
    stickyBuy.addEventListener('click', function (e) {
      e.preventDefault();
      if (form) form.requestSubmit();
    });
  }

  var claimBtn = root.querySelector('#claimBtn');
  if (claimBtn) {
    claimBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* video modal */
  var modal = root.querySelector('#pankajVideoModal');
  var modalFrame = root.querySelector('#pankajVideoFrame');
  var modalClose = root.querySelector('#pankajVideoClose');

  function openVideo(url) {
    if (!modal || !modalFrame) return;
    if (!url) return;
    var embed = url;
    if (url.indexOf('youtube.com/watch') !== -1) {
      embed = url.replace('watch?v=', 'embed/') + '?autoplay=1';
    } else if (url.indexOf('youtu.be/') !== -1) {
      embed = 'https://www.youtube.com/embed/' + url.split('youtu.be/')[1] + '?autoplay=1';
    }
    modalFrame.src = embed;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeVideo() {
    if (!modal || !modalFrame) return;
    modal.classList.remove('open');
    modalFrame.src = '';
    document.body.style.overflow = '';
  }

  if (modalClose) modalClose.addEventListener('click', closeVideo);
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeVideo();
    });
  }

  var iv = root.querySelector('#installVideo');
  if (iv) {
    iv.addEventListener('click', function () {
      openVideo(iv.dataset.videoUrl || '');
    });
  }

  root.querySelectorAll('.hero-reel-wrap').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var muteBtn = wrap.querySelector('.hero-reel-mute');
    if (!video) return;

    function syncState() {
      wrap.classList.toggle('is-playing', !video.paused && !video.ended);
      wrap.classList.toggle('is-paused', video.paused || video.ended);
      if (muteBtn) muteBtn.classList.toggle('is-muted', video.muted);
    }

    function togglePlay() {
      if (video.paused || video.ended) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
      syncState();
    }

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('.hero-reel-mute')) return;
      togglePlay();
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        syncState();
      });
    }

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    video.addEventListener('ended', syncState);

    syncState();

    if (wrap.dataset.autoplay === 'true') {
      var reelObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.muted = true;
            if (muteBtn) muteBtn.classList.add('is-muted');
            video.play().catch(function () {});
          } else {
            video.pause();
          }
          syncState();
        });
      }, { threshold: 0.45 });
      reelObs.observe(wrap);
    }
  });

  root.querySelectorAll('.vid').forEach(function (v) {
    v.addEventListener('click', function () {
      openVideo(v.dataset.videoUrl || '');
    });
  });

  /* gallery */
  var main = root.querySelector('#galMain');
  root.querySelectorAll('.thumb').forEach(function (th) {
    th.addEventListener('click', function () {
      root.querySelectorAll('.thumb').forEach(function (x) {
        x.setAttribute('aria-selected', 'false');
      });
      th.setAttribute('aria-selected', 'true');
      if (main) {
        main.style.display = '';
        var fb = main.nextElementSibling;
        if (fb) fb.style.display = 'none';
        main.src = th.dataset.src;
      }
    });
  });

  /* privacy angle demo — handled in pankaj-product-hero section {% javascript %} */

  /* before / after slider */
  var ba = root.querySelector('#ba');
  var crack = root.querySelector('#baCrack');
  var handle = root.querySelector('#baHandle');

  function setBA(pct) {
    pct = Math.max(0, Math.min(100, pct));
    if (crack) crack.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    if (handle) handle.style.left = pct + '%';
  }

  if (ba) {
    setBA(50);
    var dragging = false;
    function pos(e) {
      var r = ba.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setBA((x / r.width) * 100);
    }
    ba.addEventListener('mousedown', function (e) { dragging = true; pos(e); });
    window.addEventListener('mousemove', function (e) { if (dragging) pos(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    ba.addEventListener('touchstart', function (e) { dragging = true; pos(e); }, { passive: true });
    ba.addEventListener('touchmove', function (e) { if (dragging) pos(e); }, { passive: true });
    ba.addEventListener('touchend', function () { dragging = false; });
  }

  /* comparison rows */
  var rows = [
    '9H tempered glass',
    'Anti-blister frame',
    'Installs without bubbles',
    '360° privacy filter',
    'Ultra HD clarity',
    'Hydrophobic coating',
    '30-day return policy'
  ];
  var ok = '<div class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m5 13 4 4L19 7"/></svg></div>';
  var no = '<div class="no"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 6l12 12M18 6 6 18"/></svg></div>';
  var holder = root.querySelector('#cmpRows');
  if (holder && holder.children.length === 0) {
    holder.classList.remove('cmp-row');
    holder.style.display = 'block';
    holder.style.padding = '0';
    holder.innerHTML = rows.map(function (r) {
      return '<div class="cmp-row"><div>' + r + '</div>' + ok + no + '</div>';
    }).join('');
  }

  /* countdown */
  var DUR = 4 * 3600 * 1000;
  var key = 'arctiqo_dl';
  var dl;
  try {
    var s = sessionStorage.getItem(key);
    dl = s ? +s : Date.now() + DUR;
    sessionStorage.setItem(key, dl);
  } catch (e) {
    dl = Date.now() + DUR;
  }
  var tEl = root.querySelector('#timer');
  function p(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    if (!tEl) return;
    var d = dl - Date.now();
    if (d <= 0) {
      dl = Date.now() + DUR;
      try { sessionStorage.setItem(key, dl); } catch (e) {}
      d = DUR;
    }
    tEl.textContent = p(Math.floor(d / 3600000)) + ':' + p(Math.floor((d % 3600000) / 60000)) + ':' + p(Math.floor((d % 60000) / 1000));
  }
  tick();
  setInterval(tick, 1000);

  /* sticky bar */
  var bar = root.querySelector('#sticky');
  var hero = root.querySelector('.hero');
  function onScroll() {
    if (bar && hero) bar.classList.toggle('show', hero.getBoundingClientRect().bottom < 90);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* cart count */
  var cartEl = root.querySelector('#pankajCartCount');
  if (cartEl) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartEl.textContent = cart.item_count || 0;
      })
      .catch(function () {});
  }
})();
